import { useState } from 'react';
import { useLiveData } from '../../live/LiveDataProvider';
import { usePrematchData } from '.././PrematchDataFetcher';
import BetSelector from '../../common/BetSelector';
import ErrorMessage from '../../common/ErrorMessage';
import EventStats from '../../common/EventStats';
import HandicapDesc from '../../common/HandicapDesc';
import Img from '../../common/Img';
import Modal from '../../common/Modal';
import { openModal } from '../../common/ModalContainer';
import Odd from '../../common/Odd';
import OddSelector from '../../common/OddSelector';
import FavoriteEventToggle from '../../common/favorite-events/FavoriteEventToggle';
import Link from '../../router/Link';
import { getEventUrl } from '../Prematch';
import { getUniqueId, isOddSelector } from '../Tournament';
import { getLabel } from '../../InitData';

export default function Tournament(props) {
    const prematchData = usePrematchData();
    const liveData = useLiveData();
    const baseData = prematchData || liveData;
    const data = props.data;
    const bets = data.events[0].bets;
    const [selected, setSelected] = useState(bets.length === 1 ? [bets[0]] : [bets[0], bets[1]]);
    const ids = new Set(selected.map(b => b.id));

    function changeBet(index, id) {
        setSelected(prev => {
            prev[index] = id;
            return Array.from(prev);
        });
    }
    
    try {
        const sport = baseData.sportById[data.sportRef];
    
        return (
            <>
                <div className="c_24">
                    <div className="c_24_1">
                        <div className="c_24_1_1">{sport.descrizione} - {data.descrizione || data.desc}</div>
                        <div className="c_24_1_2">
                            <span className="c_24_1_2_1">{getLabel('general.alias')}</span>
                        </div>
                        <div className="c_24_1_3">
                            <div className="c_26">
                                {selected.map((b, i) =>
                                    <BetSelector key={b.uniqueId}
                                                 bets={bets}
                                                 toFilter={ids}
                                                 selected={b}
                                                 changeBet={(id) => changeBet(i, id)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="c_24_2">
                        <div className="c_24_2_1">
                            <div className="c_26">
                                {selected.map(b =>
                                    <div key={b.uniqueId} className="c_27">
                                        {b.parametrica &&
                                            <div className="c_28">{b.handicapTableDesc}</div>
                                        }
                                        {!isOddSelector(b) && b.odds.map(o =>
                                            <div key={o.uniqueId} className="c_28">{o.descNoHandicap || o.desc}</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {data.events.map(e => {
                        const betsById = new Map();
                        e.bets.forEach(b => betsById.set(b.id, b));
                        const bets = selected.map(b => betsById.get(b.id));
                        const url = getEventUrl(e);
    
                        function handleClick(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            openModal(
                                <Modal title={'Stats'} type="big">
                                    <EventStats data={e} />
                                </Modal>
                            );
                        }
                        
                        return (
                            <Link href={url} key={e.uniqueId} className="c_24_3">
                                <div className="c_24_3_1">
                                    <span className="c_24_3_1_1">{e.dateShort}</span>
                                    <span className="c_24_3_1_1">{e.time}</span>
                                </div>
                                <div className="c_24_3_2">
                                    <div className="c_24_3_2_1">
                                        <span className="c_24_3_2_1_2" title={e.team1}>{e.team1}</span>
                                    </div>
                                    <div className="c_24_3_2_1">
                                        <span className="c_24_3_2_1_2" title={e.team2}>{e.team2}</span>
                                    </div>
                                </div>
                                <div className="c_24_3_3">
                                    {e.alias}
                                </div>
                                <div className="c_24_3_4">
                                    <div className="c_26">
                                        {bets.map(b =>
                                            <div key={b.uniqueId} className="c_27">
                                                {b.parametrica &&
                                                    <HandicapDesc desc={b.handicapDesc} />
                                                }
                                                {isOddSelector(b) ?
                                                    <OddSelector odds={b.odds} />
                                                    :
                                                    (b.odds.map(o =>
                                                        <Odd key={o.uniqueId} data={o} type={2} />
                                                    ))
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="c_24_3_5">
                                    <Img className="c_24_3_5_1" src="icon_stats.svg" height="16px" width="16px" onClick={handleClick} />
                                    <div className="c_24_3_5_2">
                                        <span className="c_24_3_5_2_1">+{e.plus}</span>
                                        <Img className="c_24_3_5_2_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" />
                                    </div>
                                </div>
                                <FavoriteEventToggle className="c_24_3_6" id={getUniqueId(e)} />
                            </Link>
                        );
                    })}
                </div>
            </>
        );
    } catch (e) {
        console.error(e);
        return (
            <ErrorMessage message={getLabel('general.error')} />
        );
    }
}
